<template>
  <div class="footer">
    <div class="footer-links">
      <template v-if="!user">
        <span class="footer-link" @click="$emit('open-login')">log in</span>
        <span class="footer-separator">-</span>
        <span class="footer-link" @click="$emit('open-signup')">sign up</span>
        <span class="footer-separator">-</span>
        <span class="footer-link" @click="toggleAbout">about</span>
      </template>
      <template v-else>
        <span class="footer-link" @click="$emit('open-profile')">profile</span>
        <span class="footer-separator">-</span>
        <span class="footer-link" @click="toggleAbout">about</span>
      </template>
    </div>
    <div class="container invert">
      <socials></socials>
    </div>
  </div>
</template>

<script>
import Socials from './socials.vue'
import AppEvent from "./event.vue";
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export default {
  name: "AppFooter",
  components: {
    Socials,
    AppEvent
  },
  props: {
    button1: {
      type: String,
      default: "log in",
    },
    logo_path: {
      type: String,
      default: '/playground_assets/logo.png',
    },
    showAbout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: null
    }
  },
  created() {
    onAuthStateChanged(auth, user => {
      this.user = user;
    });
  },
  methods: {
    toggleAbout () {
      if (!this.showAbout) {
        this.$emit("open-about");
      } else {
        this.$emit("close-about")
      }
    }
  }
};
</script>

<style scoped>
.footer {
  display: none;
}
.about {
  font-family: Syne;
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  color:#fff;
  padding-top: 20px;
}
.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  flex-direction: row;
}
.footer-link {
  font-family: Syne;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
}
.footer-separator {
  font-family: Syne;
  font-size: .75rem;
  color: #fff;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.container {
  margin-top: 1.5rem;
  flex-direction: row;
}
.invert {
  filter: invert(100);
}
@media(max-width: 768px) {
  .footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 40px;
    justify-content: center;
    background-color: #000;
  }
}
</style>
